import * as operation from '../operation'

export const setLocal = (type, payload, replace = true) => ({
  type,
  payload,
  operation: operation.GET,
  replace,
})
